module.exports = __webpack_public_path__ + "img/img2.10420cf1.svg";